import apiRequestService from '@/commonProject/service/apiRequestService';

export default class consultationWebRepository {
    /**
     * 利用者一覧API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postCliLstActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/clilst', requestBody, idToken);
        return result;
    }
    /**
     * 利用者一覧ダウンロードAPI
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postCliDldActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/clidld', requestBody, idToken);
        return result;
    }
    /**
     * 利用者一覧アップロードAPI
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postCliUldActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/cliuld', requestBody, idToken);
        return result;
    }
    /**
     * 利用者契約一括割当API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postCliConBlkActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/cliconblk', requestBody, idToken);
        return result;
    }
    /**
     * 利用者取得API
     * @param {*} API_URL
     * @param {*} queryParam
     * @returns
     */
    async getCliDtlActionApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/clidtl', queryParam, idToken);
        return result;
    }
    /**
     * 利用者登録API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postCliDtlActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/clidtl', requestBody, idToken);
        return result;
    }
    /**
     * 利用者更新API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async putCliDtlActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/clidtl', requestBody, idToken);
        return result;
    }
    /**
     * 組織選択API
     * @param {*} API_URL
     * @param {*} queryParam
     * @returns
     */
    async getOrgSelActionApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/orgsel', queryParam, idToken);
        return result;
    }
    /**
     * 企業契約情報取得API
     * @param {*} API_URL
     * @param {*} queryParam
     * @returns
     */
    async getCmpConActionApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/cmpcon', queryParam, idToken);
        return result;
    }
    /**
     * 組織一覧API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postOrgLstActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/orglst', requestBody, idToken);
        return result;
    }
    /**
     * 組織一覧ダウンロードAPI
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postOrgDldActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/orgdld', requestBody, idToken);
        return result;
    }
    /**
     * 組織一覧アップロードAPI
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postOrgUldActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/orguld', requestBody, idToken);
        return result;
    }
    /**
     * 組織取得API
     * @param {*} API_URL
     * @param {*} queryParam
     * @returns
     */
    async getOrgDtlActionApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/orgdtl', queryParam, idToken);
        return result;
    }
    /**
     * 組織登録API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postOrgDtlActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/orgdtl', requestBody, idToken);
        return result;
    }
    /**
     * 組織更新API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async putOrgDtlActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/orgdtl', requestBody, idToken);
        return result;
    }
    /**
     * 組織削除API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postOrgDelActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/orgdel', requestBody, idToken);
        return result;
    }
    /**
     * 職種一覧API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postJobLstActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/joblst', requestBody, idToken);
        return result;
    }
    /**
     * 職種一覧ダウンロードAPI
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postJobDldActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/jobdld', requestBody, idToken);
        return result;
    }
    /**
     * 職種一覧アップロードAPI
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postJobUldActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/jobuld', requestBody, idToken);
        return result;
    }
    /**
     * 職種登録API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postJobDtlActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/jobdtl', requestBody, idToken);
        return result;
    }
    /**
     * 職種更新API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async putJobDtlActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/jobdtl', requestBody, idToken);
        return result;
    }
    /**
     * 職種削除API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postJobDelActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/jobdel', requestBody, idToken);
        return result;
    }
    /**
     * 職種取得API
     * @param {*} API_URL
     * @param {*} queryParam
     * @returns
     */
    async getJobDtlActionApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/jobdtl', queryParam, idToken);
        return result;
    }
    /**
     * 職位一覧API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postPosLstActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/poslst', requestBody, idToken);
        return result;
    }
    /**
     * 職位一覧ダウンロードAPI
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postPosDldActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/posdld', requestBody, idToken);
        return result;
    }
    /**
     * 職位一覧アップロードAPI
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postPosUldActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/posuld', requestBody, idToken);
        return result;
    }
    /**
     * 職位登録API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postPosDtlActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/posdtl', requestBody, idToken);
        return result;
    }
    /**
     * 職位更新API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async putPosDtlActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/posdtl', requestBody, idToken);
        return result;
    }
    /**
     * 職位削除API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postPosDelActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/posdel', requestBody, idToken);
        return result;
    }
    /**
     * 職位取得API
     * @param {*} API_URL
     * @param {*} queryParam
     * @returns
     */
    async getPosDtlActionApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/posdtl', queryParam, idToken);
        return result;
    }
    /**
     * 雇用形態一覧API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postEtpLstActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/etplst', requestBody, idToken);
        return result;
    }
    /**
     * 雇用形態一覧ダウンロードAPI
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postEtpDldActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/etpdld', requestBody, idToken);
        return result;
    }
    /**
     * 雇用形態一覧アップロードAPI
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postEtpUldActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/etpuld', requestBody, idToken);
        return result;
    }
    /**
     * 雇用形態登録API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postEtpDtlActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/etpdtl', requestBody, idToken);
        return result;
    }
    /**
     * 雇用形態更新API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async putEtpDtlActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/etpdtl', requestBody, idToken);
        return result;
    }
    /**
     * 雇用形態削除API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postEtpDelActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/etpdel', requestBody, idToken);
        return result;
    }
    /**
     * 雇用形態取得API
     * @param {*} API_URL
     * @param {*} queryParam
     * @returns
     */
    async getEtpDtlActionApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/etpdtl', queryParam, idToken);
        return result;
    }
    /**
     * 勤務地一覧API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postLocLstActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/loclst', requestBody, idToken);
        return result;
    }
    /**
     * 勤務地一覧ダウンロードAPI
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postLocDldActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/locdld', requestBody, idToken);
        return result;
    }
    /**
     * 勤務地一覧アップロードAPI
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postLocUldActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/loculd', requestBody, idToken);
        return result;
    }
    /**
     * 勤務地登録API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postLocDtlActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/locdtl', requestBody, idToken);
        return result;
    }
    /**
     * 勤務地更新API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async putLocDtlActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/locdtl', requestBody, idToken);
        return result;
    }
    /**
     * 勤務地削除API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postLocDelActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/locdel', requestBody, idToken);
        return result;
    }
    /**
     * 勤務地取得API
     * @param {*} API_URL
     * @param {*} queryParam
     * @returns
     */
    async getLocDtlActionApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/locdtl', queryParam, idToken);
        return result;
    }
    /**
     * 時間外労働時間一覧API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postOvtLstActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/ovtlst', requestBody, idToken);
        return result;
    }
    /**
     * 時間外労働時間一覧ダウンロードAPI
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postOvtDldActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/ovtdld', requestBody, idToken);
        return result;
    }
    /**
     * 時間外労働時間一覧アップロードAPI
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postOvtUldActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/ovtuld', requestBody, idToken);
        return result;
    }
    /**
     * 時間外労働時間登録API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postOvtDrlActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/ovtdtl', requestBody, idToken);
        return result;
    }
    /**
     * 時間外労働時間更新API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async putOvtDrlActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/ovtdtl', requestBody, idToken);
        return result;
    }
    /**
     * 時間外労働時間取得API
     * @param {*} API_URL
     * @param {*} queryParam
     * @returns
     */
    async getOvtDtlActionApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/ovtdtl', queryParam, idToken);
        return result;
    }
    /**
     * 時間外労働時間削除API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postOvtDelActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/ovtdel', requestBody, idToken);
        return result;
    }
    /**
     * CSV取込履歴一覧API
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postCsvImpLstActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/csvimplst', requestBody, idToken);
        return result;
    }
    /**
     * CSVファイルダウンロードAPI
     * @param {*} API_URL
     * @param {*} requestBody
     * @returns
     */
    async postcsvFilDldActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/csvfildld', requestBody, idToken);
        return result;
    }
}
